import { IEmpletAllele } from '@nkr/models/index';
import { AlleleType } from '@nkr/enums/index';
import { Badge, Button, Col, Label, OverlayTrigger, Row } from 'react-bootstrap';
import PopoverTemplate from '@nkr/components/popover-template';
import { EpletDetailsTableWrapper } from './styles';

interface IProps {
    alleles: IEmpletAllele,
    allelesType: number,
    isAdmin: boolean,
    placement?: string,
    width?: string,
    height?: string,
    dismiss?: boolean,
    label?: string
}

const AlleleDetails = (props: IProps) => {
    const getEpletHtml = function (eplets) {
        let jsxElements = [];

        if (eplets) {
            eplets.forEach((eplet) => {
                let buttonLabel = eplet.hasAntibodyReactivity ? 'danger' : 'warning';
                jsxElements.push(
                    <Col xs={3} style={{ marginTop: '3px' }} key={eplet.name}>
                        <Label bsStyle={buttonLabel}>{eplet.name}</Label>
                    </Col>
                );
            });

            if (jsxElements.length > 0) {
                return (
                    <Row>
                        <Col xs={12}>
                            <strong>Mismatched Eplets</strong>
                        </Col>
                        {jsxElements}
                    </Row>
                );
            }
        }
        return null;
    };

    let buttonLabel = 'default';
    let badgeStyle = null;
    let buttonText = '- ? -';
    let foundInDb = '';
    let riskHtml = null;
    let epletHtml = null;

    let { hlaString,
        isInDb,
        isDr,
        isDq,
        isRisk,
        epletCountAll,
        epletCountMismatch,
        epletsMismatched
    } = props.alleles;

    if (props.allelesType == AlleleType.RecipientAllele) {
        if (isInDb) {
            buttonLabel = 'info';
        }
        buttonText = hlaString.replace(/(\w+\*\d+\:\d+)\:?[^N]*(N?)/, "$1$2");
        foundInDb = /N$/.test(hlaString) ? "N/A (not expressed)" : (isInDb ? 'Yes' : 'No');
    }

    const dangerStyle = {
        backgroundColor: 'red',
        color: 'white'
    };

    if (props.allelesType == AlleleType.DonorAllele) {
        isRisk = (isDr && epletCountMismatch > 6) || (isDq && epletCountMismatch > 8);
        buttonLabel = epletCountMismatch > 0 ? 'warning' : (isInDb ? 'success' : 'default');
        badgeStyle = isRisk ? dangerStyle : '';
        buttonText = hlaString.replace(/(\w+\*\d+\:\d+)\:?[^N]*(N?)/, "$1$2");
        foundInDb = /^NEW/.test(hlaString) ? 'New Allele' : (/N$/.test(hlaString) ? "N/A (not expressed)" : (isInDb ? 'Yes' : 'No'));
        epletHtml = getEpletHtml(epletsMismatched);
        riskHtml = !isRisk ? '' : (
            <Row>
                <Col xs={12}>
                    <Label bsStyle="danger">Potential risk on single molecule eplet mismatch.</Label><br />
                    <a href="https://www.ncbi.nlm.nih.gov/pubmed/30414349" target="_blank" rel="noopener noreferrer">See research</a>.
                </Col>
            </Row>
        );
    }

    const Overlay = (
        <PopoverTemplate dismiss={props.dismiss}>
            <div style={{ minWidth: 400 }}>
                <div style={{ marginBottom: 10, fontSize: 'large', padding: 5 }}>Allele Details</div>
                <EpletDetailsTableWrapper condensed striped>
                    <tbody>
                        <tr>
                            <td style={{ width: '40%' }}><strong>HLA Details:</strong></td>
                            <td style={{ width: '60%' }}>{hlaString}</td>
                        </tr>
                        <tr>
                            <td><strong>Found in DB:</strong></td>
                            <td>{foundInDb}</td>
                        </tr>
                        <tr>
                            <td><strong>Total Eplet Count:</strong></td>
                            <td>{epletCountAll}</td>
                        </tr>

                        {props.allelesType === AlleleType.DonorAllele && (
                            <>
                                <tr style={{ borderBottom: '1px solid lightgrey' }}>
                                    <td><strong>Single Molecule Eplet Mismatch</strong>:</td>
                                    <td>{epletCountMismatch}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <div>
                                            {riskHtml}
                                            {epletHtml}
                                        </div>
                                    </td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </EpletDetailsTableWrapper>
            </div>
        </PopoverTemplate>
    );

    return (
        <div>
            {props.allelesType == AlleleType.RecipientAllele && (
                <OverlayTrigger trigger='click' placement={props.placement != null ? props.placement : 'right'} rootClose overlay={Overlay}>
                    <Button bsStyle={buttonLabel} bsSize="xs" style={{ height: props.height, width: props.width ? props.width : '100%', marginBottom: '4px' }}> {buttonText.toUpperCase()} </Button>
                </OverlayTrigger>
            )}

            {props.allelesType == AlleleType.DonorAllele && (<>
                <OverlayTrigger trigger="click" placement={props.placement != null ? props.placement : 'right'} rootClose overlay={Overlay}>
                    <Button bsStyle={buttonLabel} bsSize="xs" style={{ height: props.height, width: props.width ? props.width : '100%', marginBottom: '4px', position: 'relative' }}> {buttonText.toUpperCase()}
                        <Badge style={{ position: 'absolute', right: 3, top: 3, backgroundColor: isRisk ? '#d9534f' : '#777777', color: 'white' }}>{epletCountMismatch}</Badge>
                    </Button>
                </OverlayTrigger>
            </>)}
        </div>
    );
}

export default AlleleDetails;